import Vue from "vue";

Vue.prototype.$formames = [
  { key: "f_long_form" },
  { key: "f_large_form" },
  { key: "f_high_point" },
  { key: "f_circ_meta" },
  { key: "f_circ_retrometa" },
  { key: "f_circ_neck" },
  { key: "f_circ_pass" },
  { key: "f_circ_mall" },
  { key: "f_circ_term_tom" },
  { key: "f_high_term_tom" },
  { key: "f_high_tot" }
];
